import React from 'react'

export default function PageTitle({
  titleText,
  subTitleText = null,
  margins = '',
  otherStyles = ''
}) {
  return (
    <div className={`${margins || 'mt-2'} flex flex-col`}>
      <div className=' md:hidden md:h-0'>
        <h1 className='text-center font-bold text-xl text-color-black'>
          {titleText}
        </h1>
      </div>
      {subTitleText && (
        <div className='mb-6'>
          <h2 className={`font-medium text-xs text-color-black ${otherStyles}`}>
            {subTitleText}
          </h2>
        </div>
      )}
    </div>
  )
}
